import React from 'react'
import styles from './DownloadQRCodes.module.css'

const DownloadQRCodes = () => {
    return (
        <div>DownloadQRCodes</div>
    )
}

export default DownloadQRCodes